export default {
    dynamicFormsViewAnswers_title: "Answers",
    dynamicFormsViewAnswers_updatedAt: "Updated At",
    dynamicFormsViewAnswers_updatedBy: "Updated by",
    dynamicFormsViewAnswers_advancedFilters: "Pages",
}